export default class {

	constructor(obj) {
		this.id = obj.pickupid
		this.date = obj.pickupdate
		this.sampleNumber = obj.pickupsample
		this.comments = obj.pickupcomment
		this.producerReference = obj.pickupproducer
		this.idStation = obj.pickupqualitometer
	}
}



// WEBPACK FOOTER //
// ./src/station/dto/DtoPickupOperation.js